export default {
  'table.total': 'Total: {{amount}} items',
  'table.actions': 'Actions',
};
